var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { facebookTrackingService } from '@/services/tracking';
import httpClient from '@/services/api/axios';
export default defineComponent({
    name: 'blue-add-cart',
    computed: Object.assign({}, mapGetters('blue', {
        currentProduct: 'currentProduct',
    })),
    methods: Object.assign(Object.assign({}, mapActions('blue', {
        addProductToCart: 'ADD_PRODUCT',
    })), { addProduct() {
            return __awaiter(this, void 0, void 0, function* () {
                facebookTrackingService.trackCartAdd(this.currentProduct, 1);
                this.addProductToCart({
                    product_id: this.currentProduct.id,
                    quantity: 1,
                }).finally(() => {
                    httpClient.get(`/kaufen/shoppingcart/addCartModal/${this.currentProduct.id}`).then((response) => {
                        const canvas = document.getElementById('JS_addCartContentWrapper');
                        if (!canvas) {
                            return;
                        }
                        canvas.innerHTML = response.data;
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        //@ts-ignore
                        window.jQuery('#cart-add-modal').modal('show');
                        window.dispatchEvent(new CustomEvent('scroll', { detail: { deltaY: 1 } }));
                    });
                });
            });
        } }),
});
